export var combineActionOptions = function combineActionOptions(_ref) {
  var actionOptions = _ref.actionOptions,
    platform = _ref.platform;
  if (typeof actionOptions !== 'undefined') {
    return actionOptions;
  }
  if (platform === 'mobile') {
    return {
      hide: true
    };
  }
  var exclude = [];
  return {
    hide: false,
    exclude: exclude
  };
};